<template>
  <table class="table table-sm table-bordered table-hover">
    <thead>
      <tr>
        <th style="width: 90px">Активний</th>
        <th>ПІБ</th>
        <th>Логін</th>
        <th style="width: 100px">Авто зміна</th>
        <th style="width: 120px">Зміна</th>
        <th style="width: 100px">Режим</th>
        <th class="counterparties-header">Відправники/Відділення</th>
        <th style="width: 120px">Дії</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in items" :key="item.id" :class="{ 'cashier-inactive': !item.is_active }">
        <td class="text-center">
          <i v-if="item._activeLoading" class="fa fa-spinner fa-spin text-muted"></i>
          <toggle-button
            v-else
            :value="item.is_active"
            :margin="0"
            :width="40"
            :height="20"
            color="#94D974"
            @change="$emit('toggleActive', item, $event)"
          />
        </td>
        <td>{{ item.full_name }}</td>
        <td>{{ item.login }}</td>
        <td class="text-center">
          <i v-if="item._autoShiftLoading" class="fa fa-spinner fa-spin text-muted"></i>
          <toggle-button
            v-else
            :value="item.auto_shift"
            :margin="0"
            :width="40"
            :height="20"
            color="#94D974"
            @change="$emit('toggleAutoShift', item, $event)"
          />
        </td>
        <td class="text-center shift-cell">
          <span v-if="!item.is_active" class="text-muted">—</span>
          <div
            v-else
            class="shift-toggle-wrapper"
            :title="item._shiftOpened && item._shiftOpenedAt ? 'Відкрито: ' + formatDateTime(item._shiftOpenedAt) : ''"
          >
            <i v-if="item._shiftLoading" class="fa fa-spinner fa-spin text-muted"></i>
            <toggle-button
              v-else
              :value="item._shiftOpened"
              :margin="0"
              :width="40"
              :height="20"
              color="#94D974"
              @change="$emit('toggleShift', item, $event)"
            />
          </div>
        </td>
        <td class="text-center mode-cell">
          <b-button-group size="sm">
            <b-button
              :variant="item.mode === 'sender' ? 'primary' : 'outline-secondary'"
              @click="$emit('changeMode', item, 'sender')"
              title="Відправник НП"
              :disabled="item._modeLoading"
              class="mode-btn"
            >
              <i class="fa fa-user"></i>
            </b-button>
            <b-button
              :variant="item.mode === 'department' ? 'primary' : 'outline-secondary'"
              @click="$emit('changeMode', item, 'department')"
              title="Відділ"
              :disabled="item._modeLoading"
              class="mode-btn"
            >
              <i class="fa fa-building"></i>
            </b-button>
          </b-button-group>
        </td>
        <td class="text-center counterparties-cell">
          <b-button
            variant="link"
            size="sm"
            class="counterparties-btn"
            :class="{ 'has-items': getLinkedItems(item).length }"
            @click="$emit('openCounterpartiesPopup', item)"
            :disabled="item._counterpartiesLoading"
            :title="getLinkedItemsTooltip(item)"
          >
            <i v-if="item._counterpartiesLoading" class="fa fa-spinner fa-spin"></i>
            <template v-else>
              <span class="badge" :class="getLinkedItems(item).length ? 'badge-info' : 'badge-secondary'">
                {{ getLinkedItems(item).length }}
              </span>
              <i class="fa fa-pencil ml-1 edit-icon"></i>
            </template>
          </b-button>
          <div class="counterparties-names" :title="getLinkedItemsTooltip(item)">
            <template v-if="getLinkedItems(item).length">
              <div v-for="linked in getLinkedItems(item)" :key="linked.id" class="counterparty-name">
                {{ getLinkedItemName(linked) }}
              </div>
            </template>
            <span v-else class="text-muted">—</span>
          </div>
        </td>
        <td class="actions-cell">
          <b-button variant="link" size="sm" @click="$emit('openEditModal', item)" title="Редагувати">
            <i class="fa fa-edit"></i>
          </b-button>
          <b-button variant="link" size="sm" class="text-danger" @click="$emit('confirmDelete', item)" title="Видалити">
            <i class="fa fa-trash"></i>
          </b-button>
        </td>
      </tr>
      <tr v-if="!items.length && hasLoaded">
        <td colspan="8" class="text-center text-muted py-3">
          Немає касирів. Натисніть "Додати касира" щоб створити нового.
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'CashiersTabList',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    hasLoaded: {
      type: Boolean,
      default: false,
    },
    getLinkedItems: {
      type: Function,
      required: true,
    },
    getLinkedItemsTooltip: {
      type: Function,
      required: true,
    },
    getLinkedItemName: {
      type: Function,
      required: true,
    },
    formatDateTime: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.counterparties-names {
  margin-top: 2px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  font-size: 10px;
  line-height: 1.1;
  color: #6c757d;
  max-width: 200px;
}

.counterparty-name {
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 10px;
  background: #eef2f5;
  border: 1px solid #dde3e8;
  color: #495057;
  white-space: nowrap;
}

.counterparties-header {
  width: 110px;
  font-size: 11px;
  line-height: 1.2;
}

.cashier-inactive {
  color: #adb5bd;
}

.cashier-inactive .btn {
  color: #adb5bd;
}
</style>
